module.exports = __webpack_public_path__ + "static/media/execute_exitPractise.04dad3a4.png";